namespace GeniuzPOS.InitialData {
    export interface IcWhsRow {
        Id?: number;
        WhsId?: string;
        WhsName?: string;
        WhsType?: IcWhsGenEnumWhsType;
        ShopId?: string;
        ShopFullName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace IcWhsRow {
        export const idProperty = 'WhsId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'InitialData.IcWhs';
        export const lookupKey = 'InitialData.IcWhs';

        export function getLookup(): Q.Lookup<IcWhsRow> {
            return Q.getLookup<IcWhsRow>('InitialData.IcWhs');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:คลัง:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:คลัง:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:คลัง:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:คลัง:Modify';

        export declare const enum Fields {
            Id = "Id",
            WhsId = "WhsId",
            WhsName = "WhsName",
            WhsType = "WhsType",
            ShopId = "ShopId",
            ShopFullName = "ShopFullName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
